import { ITuple2 } from "../component-data-structure";
import { BezierData } from "./bezier";

// export enum IEasing {
//     linear = 'linear',
//     tie = 'tie',
//     smooth = 'smooth',
//     accelerating = 'accelerating',
//     decelerating = 'decelerating',
//     easeInQuad = 'easeInQuad',
//     easeOutQuad = 'easeOutQuad',
//     easeInOutQuad = 'easeInOutQuad',
//     easeInCubic = 'easeInCubic',
//     easeOutCubic = 'easeOutCubic',
//     easeInOutCubic = 'easeInOutCubic',
//     easeInQuart = 'easeInQuart',
//     easeOutQuart = 'easeOutQuart',
//     easeInOutQuart = 'easeInOutQuart',
//     easeInQuint = 'easeInQuint',
//     easeOutQuint = 'easeOutQuint',
//     easeInOutQuint = 'easeInOutQuint',
//     easeInSine = 'easeInSine',
// 	easeOutSine = 'easeOutSine',
// 	easeInOutSine = 'easeInOutSine',
// 	easeInCirc = 'easeInCirc',
// 	easeOutCirc = 'easeOutCirc',
// 	easeInOutCirc = 'easeInOutCirc',
// 	easeInExpo = 'easeInExpo',
// 	easeOutExpo = 'easeOutExpo',
// 	easeInOutExpo = 'easeInOutExpo',
// 	easeInElastic = 'easeInElastic',
// 	easeOutElastic = 'easeOutElastic',
// 	easeInOutElastic = 'easeInOutElastic',
// 	easeInBack = 'easeInBack',
// 	easeOutBack = 'easeOutBack',
// 	easeInOutBack = 'easeInOutBack',
// 	easeOutBounce = 'easeOutBounce',
// 	easeInBounce = 'easeInBounce',
// 	easeInOutBounce = 'easeInOutBounce'
// }

export enum IEasingTypes {
    linear = 'linear',
    smooth = 'smooth',

    accelerating = 'accelerating',
    decelerating = 'decelerating',

    easeInQuad = 'easeInQuad',
    easeOutQuad = 'easeOutQuad',
    easeInOutQuad = 'easeInOutQuad',

	easeInBack = 'easeInBack',
	easeOutBack = 'easeOutBack',
	easeInOutBack = 'easeInOutBack',

	easeOutBounce = 'easeOutBounce',
	easeOutElastic = 'easeOutElastic'
}

export const easingNamesByTypesDict: {[k: string]: string} = {
	[IEasingTypes.linear]: 'Linear',
	//[IEasingTypes.smooth]: 'Smooth',
	//[IEasingTypes.accelerating]: 'Accelerating',
	//[IEasingTypes.decelerating]: 'Decelerating',
	[IEasingTypes.easeInQuad]: 'Ease in',
	[IEasingTypes.easeOutQuad]: 'Ease out',
	[IEasingTypes.easeInOutQuad]: 'Ease in and out',
	// [IEasingTypes.easeInBack]: 'Ease in back',
	// [IEasingTypes.easeOutBack]: 'Ease out back',
	// [IEasingTypes.easeInOutBack]: 'Ease in and out back',
	[IEasingTypes.easeOutBounce]: 'Bouncy',
	// [IEasingTypes.easeOutElastic]: 'Elastic'
}

export interface IEasingDict {
	[type: string]: (t: number) => number
}

export interface IEasingDataPointDict {
	[t:string]: BezierData[]
}

export const easingDataDict: IEasingDataPointDict = {
	[IEasingTypes.linear]: [[[0,0],[0.5,0.5],[0.5,0.5],[1,1]]],
	// [IEasingTypes.accelerating]: [[[0,0],[0.42,0],[1,1],[1,1]]],
	[IEasingTypes.easeInQuad]: [[[0,0],[0.42,0],[1,1],[1,1]]],
	[IEasingTypes.easeOutQuad]: [[[0,0],[0,0],[0.58,1],[1,1]]],
	[IEasingTypes.easeInOutQuad]: [[[0,0],[0.42,0],[0.58,1],[1,1]]],
	[IEasingTypes.easeOutBounce]: [[[0,0],[0.1,0],[0.2,0.5],[0.3,1]],[[0.3,1],[0.4,0.7],[0.6,0.7],[0.7,1]],[[0.7,1],[0.75,0.85],[0.85,0.85],[0.9,1]],[[0.9,1],[0.925,0.95],[0.975,0.95],[1,1]]]
}

// export const easing: IEasingDict = {
// 	linear: function(t) { return t; },
// 	tie: function() { return 0; },
// 	smooth: function(t) { return (-0.5 * Math.cos(3.1415926 * t)) + 0.5; },
// 	accelerating: function(t) { return t * t; },
// 	decelerating: function(t) { return 2.0 * t - 1.0 * t * t; },
// 	easeInQuad: function(t) { return t * t; },
// 	easeOutQuad: function(t) { return -(t * (t - 2.0)); },
// 	easeInOutQuad: function(t) {
// 		if (t < 0.5) return 2.0 * t * t;
// 		return (-2.0 * t * t) + (4.0 * t) - 1.0;
// 	},
// 	easeInCubic: function(t) { return t * t * t; },
// 	easeOutCubic: function(t) {
// 		const f = (t - 1.0);
// 		return f * f * f + 1.0;
// 	},
// 	easeInOutCubic: function(t) {
// 		if (t < 0.5) return 4.0 * t * t * t;
// 		const f = ((2.0 * t) - 2.0);
// 		return 0.5 * f * f * f + 1.0;
// 	},
// 	easeInQuart: function(t) { return t * t * t * t; },
// 	easeOutQuart: function(t) {
// 		const f = (t - 1.0);
// 		return 1.0 - f * f * f * f;
// 	},
// 	easeInOutQuart: function(t) {
// 		if (t < 0.5) return 8.0 * t * t * t * t;
// 		const f = (t - 1.0);
// 		return -8.0 * f * f * f * f + 1.0;
// 	},
// 	easeInQuint: function(t) { return t * t * t * t * t; },
// 	easeOutQuint: function(t) {
// 		const f = (t - 1.0);
// 		return f * f * f * f * f + 1.0;
// 	},
// 	easeInOutQuint: function(t) {
// 		let f = t * 2.0;
// 		if (f < 1.0) return 0.5 * f * f * f * f * f;
// 		f -= 2.0;
// 		return 0.5 * f * f * f * f * f + 1.0;
// 	},
// 	easeInSine: function(t) { return Math.sin((t - 1.0) * 1.5707963) + 1.0; },
// 	easeOutSine: function(t) { return Math.sin(t * 1.5707963); },
// 	easeInOutSine: function(t) { return 0.5 * (1.0 - Math.cos(t * Math.PI)); },
// 	easeInCirc: function(t) { return 1.0 - Math.sqrt(1.0 - (t * t)); },
// 	easeOutCirc: function(t) { return Math.sqrt((2.0 - t) * t); },
// 	easeInOutCirc: function(t) {
// 		if (t < 0.5) return 0.5 * (1.0 - Math.sqrt(1.0 - 4.0 * (t * t)));
// 		return 0.5 * (Math.sqrt(-((2.0 * t) - 3.0) * ((2.0 * t) - 1.0)) + 1.0);
// 	},
// 	easeInExpo: function(t) { return Math.pow(2.0, 10.0 * (t - 1.0)); },
// 	easeOutExpo: function(t) { return 1.0 - Math.pow(2.0, -10.0 * t); },
// 	easeInOutExpo: function(t) {
// 		if(t < 0.5) return 0.5 * Math.pow(2.0, (20.0 * t) - 10.0);
// 		return -0.5 * Math.pow(2.0, (-20.0 * t) + 10.0) + 1.0;
// 	},
// 	easeInElastic: function(t) {
// 		const s = 0.3 / 4.0;
// 		t -= 1.0;
// 		return -Math.pow(2.0, 10.0 * t) * Math.sin((t - s) * 1.5707963 / s);
// 	},
// 	easeOutElastic: function(t) {
// 		const s = 0.3 / 4.0;
// 		return Math.pow(2.0, -10.0 * t) * Math.sin((t - s) * 1.5707963 / s) + 1.0;
// 	},
// 	easeInOutElastic: function(t) {
// 		const s = 0.3 * 1.5 / 4.0;
// 		const f = 2.0 * t - 1.0;
// 		if(t < 0.5) return -0.5 * Math.pow(2.0, 10.0 * f) * Math.sin((f - s) * 1.5707963 / s);
// 		return 0.5 * Math.pow(2.0, -10.0 * f) * Math.sin((f - s) * 1.5707963 / s) + 1.0;
// 	},
// 	easeInBack: function(t) {
// 		const s = 1.70158; // Gives 10% overshoot
// 		return t * t * ((s + 1.0) * t - s);
// 	},
// 	easeOutBack: function(t) {
// 		const s = 1.70158;
// 		const f = (1.0 - t);
// 		return 1.0 - (f * f * ((s + 1.0) * f - s));
// 	},
// 	easeInOutBack: function(t) {
// 		let f = 2.0 * t;
// 		const s = 1.70158 * 1.525;
// 		if(f < 1) return 0.5 * (f * f * ((s + 1.0) * f - s));
// 		f = 2.0 - f;
// 		return 1.0 - 0.5 * (f * f * ((s + 1.0) * f - s));
// 	},
// 	easeOutBounce: function(t) {
// 		if(t < 4.0/11.0) return (121.0 * t * t) / 16.0;
// 		if(t < 8.0/11.0) {
// 			t -= 6.0/11.0;
// 			return (121.0 * t * t) / 16.0 + 1.0 - (0.5 * 0.5);
// 		}
// 		if(t < 10.0/11.0) {
// 			t -= 9.0/11.0;
// 			return (121.0 * t * t) / 16.0 + 1.0 - (0.25 * 0.25);
// 		}
// 		t -= 10.5/11.0;
// 		return (121.0 * t * t) / 16.0 + 1.0 - (0.125 * 0.125);
// 	},
// 	easeInBounce: function(t) {
// 		return 1.0 - this.easeOutBounce(1.0 - t);
// 	},
// 	easeInOutBounce: function(t) {
// 		if (t < 0.5) return 0.5 * this.easeInBounce(t * 2.0);
// 		return 0.5 * this.easeOutBounce(t * 2.0 - 1.0) + 0.5;
// 	}
// };
